import React, { Component } from 'react';
import { Load, Warning } from './basic';
import '../../public/less/chart.less';
import axios from 'axios';


module.exports = class chartForm extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.ID = this.props.ID;

        this.onClick = this.props.OnClick;
        //  Chart.defaults.global.legend.display = false;
        this.loadData();
    };

    loadData() {
        this
            ._loading
            .Show();

        var params = this.props.Data;

        axios
            .get(this.props.ChartAjaxUrl, { params: params })
            .then(function (data) {
                //console.log(data);
                this
                    ._loading
                    .Hide();
                this.data = data.data;
                this.createChart();

                this.props.OnLoadData(this.data);

            }.bind(this))
            .catch(function (error) {
                if (error.response && error.response.data == "No permissions") {
                    window.location.replace("/login");
                }
                console.log(error);
            });

    };

    createChart() {

        var ctx = document.getElementById(this.ID);

        var myChart = new Chart(ctx, {
            scaleShowVerticalLines: false,
            type: 'roundedBar',
            data: this.data,
            options: {
                scales: {
                    xAxes: [
                        {
                            display: true,
                            barThickness: 15,
                            categoryPercentage: 0.43,
                            barPercentage: 0.5,
                            gridLines: {
                                display: false
                            }
                        }
                    ],
                    yAxes: [
                        {
                            display: true,
                            ticks: {
                                beginAtZero: true
                            }
                        }
                    ]
                },
                legend: {
                    display: false
                },
                barRoundness: 1
            }
        });

        document
            .getElementById('js-legend' + this.props.ID)
            .innerHTML = myChart.generateLegend();

        this.chart = myChart;

        var data = this.data;
        var onClick = this.onClick;
        ctx.onclick = function (evt) {
            // console.log(evt);
            var activePoints = myChart.getElementsAtEvent(evt);
            onClick(activePoints, data);
            // => activePoints is an array of points on the canvas that are at the same
            // position as the click event.
        };

        myChart.render();


    };


    render() {
        var style = {
            width: '400px',
            height: '150px'
        }

        var legendID = 'js-legend' + this.props.ID;
        return (
            <div className='chartContainer' id={this.props.containerId} style={style}>
                <Load
                    ref={(loading) => {
                        this._loading = loading;
                    }} />
                <div id={legendID} className="chart-legend"></div>
                <canvas className='chartJs' id={this.props.ID} width="400" height="150"></canvas>
            </div>
        )
    }
};



// draws a rectangle with a rounded top
Chart.helpers.drawRoundedTopRectangle = function (ctx, x, y, width, height, radius) {
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    // top right corner
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    // bottom right	corner
    ctx.lineTo(x + width, y + height);
    // bottom left corner
    ctx.lineTo(x, y + height);
    // top left	
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
};

Chart.elements.RoundedTopRectangle = Chart.elements.Rectangle.extend({
    draw: function () {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var left, right, top, bottom, signX, signY, borderSkipped;
        var borderWidth = vm.borderWidth;

        if (!vm.horizontal) {
            // bar
            left = vm.x - vm.width / 2;
            right = vm.x + vm.width / 2;
            top = vm.y;
            bottom = vm.base;
            signX = 1;
            signY = bottom > top ? 1 : -1;
            borderSkipped = vm.borderSkipped || 'bottom';
        } else {
            // horizontal bar
            left = vm.base;
            right = vm.x;
            top = vm.y - vm.height / 2;
            bottom = vm.y + vm.height / 2;
            signX = right > left ? 1 : -1;
            signY = 1;
            borderSkipped = vm.borderSkipped || 'left';
        }

        // Canvas doesn't allow us to stroke inside the width so we can
        // adjust the sizes to fit if we're setting a stroke on the line
        if (borderWidth) {
            // borderWidth shold be less than bar width and bar height.
            var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
            borderWidth = borderWidth > barSize ? barSize : borderWidth;
            var halfStroke = borderWidth / 2;
            // Adjust borderWidth when bar top position is near vm.base(zero).
            var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
            var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
            var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
            var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
            // not become a vertical line?
            if (borderLeft !== borderRight) {
                top = borderTop;
                bottom = borderBottom;
            }
            // not become a horizontal line?
            if (borderTop !== borderBottom) {
                left = borderLeft;
                right = borderRight;
            }
        }

        // calculate the bar width and roundess
        var barWidth = Math.abs(left - right);
        var roundness = this._chart.config.options.barRoundness || 0.5;
        var radius = barWidth * roundness * 0.5;

        // keep track of the original top of the bar
        var prevTop = top;

        // move the top down so there is room to draw the rounded top
        top = prevTop + radius;
        var barRadius = top - prevTop;

        ctx.beginPath();
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        ctx.lineWidth = borderWidth;

        // draw the rounded top rectangle
        Chart.helpers.drawRoundedTopRectangle(ctx, left, (top - barRadius + 1), barWidth, bottom - prevTop, barRadius);

        ctx.fill();
        if (borderWidth) {
            ctx.stroke();
        }

        // restore the original top value so tooltips and scales still work
        top = prevTop;
    },
});

Chart.defaults.roundedBar = Chart.helpers.clone(Chart.defaults.bar);

Chart.controllers.roundedBar = Chart.controllers.bar.extend({
    dataElementType: Chart.elements.RoundedTopRectangle
});



// WEBPACK FOOTER //
// ./modules/common/chartWithoutDates.jsx